import { render, staticRenderFns } from "./Staging-View.vue?vue&type=template&id=98856a4a&scoped=true&"
import script from "./Staging-View.vue?vue&type=script&lang=js&"
export * from "./Staging-View.vue?vue&type=script&lang=js&"
import style0 from "./Staging-View.vue?vue&type=style&index=0&id=98856a4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98856a4a",
  null
  
)

export default component.exports